import React, { useEffect, useState } from "react";
import find from "lodash/find";
import ReactDatePicker from "react-datepicker";
import { User, Calendar, X } from "react-feather";
import Modal from "react-modal";
import ModalContent from "../../common/Modal/ModalContent";
import moment from "moment";
import api from "../../utils/api";
import close_modal from "./../../assets/ic_close_modal.svg";
import MultiSelectAll from "../../common/Multiselect/MultiSelectAll";
import Select from "react-select";
import SelectServiceStatusDropdown from "./SelectServiceStatusDropdown";

export default function SPLedFilterModel(props) {

  return (
    <Modal
      isOpen={props.isOpen}
      onRequestClose={props.toggleModal}
      ariaHideApp={false}
    >
      <ModalContent className="notes-filter-modal">
          <div className="modal-header-sp">
          <span className="modal-title">Filter By</span>
            <img
                alt="close"
                id="Close"
                src={close_modal}
                className="close modal-close"
                onClick={props.toggleModal}
            />
          </div>
        
        <div
            className={`modal-body spled-container notes-trail-content filter-content custom-scrollbar`}
        >
            <div className="row conv-mt20">
                <div className="col-6 width-100">
                    <ReactDatePicker
						dateFormat="dd/MM/yyyy"
						selected={props.fromDate}
						onChange={(date) =>props.setfromDate(date)}
						placeholderText="Service From Date"
					/>
                </div>
                <div className="col-6 width-100">
                    <ReactDatePicker
						dateFormat="dd/MM/yyyy"
						selected={props.toDate}
						onChange={(date) =>props.settoDate(date)}
						placeholderText="Service To Date"
					/>
                </div>
            </div>
            <div className="row conv-mt20">
                <div className="col-6 width-100">
                    <MultiSelectAll
                        toggleAll={props.toggleAllForFilter}
                        toggleSelection={props.toggleSelectionForFilter}
                        checkboxItemsList={props.serviceNameListForFilter}
                        selectedOptions={props.selectedServiceNameListForFilter}
                        placeholderButtonLabel={"Select Services"}
                    />
                </div>
                <div className="col-6">
                    <Select
						styles={{
							// Fixes the overlapping problem of the component
							menu: provided => ({ ...provided, zIndex: 3 })
						}}
						placeholder="Need to talk to SP"
						options={props.requestedaCallBackOptions}
						onChange={props.setSelectedNeedToTalkToSPOption}
						value={props.selectedNeedToTalkToSPOption}
                        isClearable
                        className='react-select-container'
                        classNamePrefix="react-select"
                        theme={theme => ({
                            ...theme,
                            colors: {
                              ...theme.colors,
                              primary: '#76287C',
                              primary25: '#F4DFF4',
                            },
                          })}
					></Select>
                </div>
            </div>
            <div className="row conv-mt20">
                <div className="col-6">
                    <Select
						styles={{
							// Fixes the overlapping problem of the component
							menu: provided => ({ ...provided, zIndex: 3 })
						}}
						placeholder="Select Package"
						options={props.packageNameListForFilter}
						onChange={(option) => {
							props.setSelectedPackageNameListForFilter(option);
						}}
						value={props.selectedPackageNameListForFilter}
						isClearable
                        className='react-select-container'
                        classNamePrefix="react-select"
                        theme={theme => ({
                            ...theme,
                            colors: {
                              ...theme.colors,
                              primary: '#76287C',
                              primary25: '#F4DFF4',
                            },
                          })}
					></Select>
                </div>
                <div className="col-6">
                    <Select
						styles={{
							// Fixes the overlapping problem of the component
							menu: provided => ({ ...provided, zIndex: 3 })
						}}
						placeholder="Select Requested by"
						options={props.requestedByOptions}
						onChange={props.setSelectedRequestedByOption}
						value={props.selectedRequestedByOption}
                        isClearable
                        className='react-select-container'
                        classNamePrefix="react-select"
                        theme={theme => ({
                            ...theme,
                            colors: {
                              ...theme.colors,
                              primary: '#76287C',
                              primary25: '#F4DFF4',
                            },
                          })}
					></Select>
                </div>
            </div>
            <div className="row conv-mt20">
                <div className="col-6">
                    {/*<SelectServiceStatusDropdown
                        toggleSelection={props.toggleServiceStatus}
                        checkboxItemsList={props.serviceStatusList}
                    />*/}
                    <MultiSelectAll
                        toggleAll={props.toggleAllForServiceStatusFilter}
                        toggleSelection={props.toggleSelectionForServiceStatusFilter}
                        checkboxItemsList={props.serviceStatusNameListForFilter}
                        selectedOptions={props.selectedServiceStatusListForFilter}
                        placeholderButtonLabel={"Select Status"}
                    />
                </div>
                <div className="col-6">
                    <Select
                      styles={{
                        // Fixes the overlapping problem of the component
                        menu: provided => ({ ...provided, zIndex: 3 })
                      }}
                      placeholder="Call Connected"
                      options={props.callStatusOptionsForFilter}
                      onChange={props.setselectedCallStatusOptionForFilter}
                      value={props.selectedCallStatusOptionForFilter}
                              isClearable
                              className='react-select-container'
                              classNamePrefix="react-select"
                              theme={theme => ({
                                  ...theme,
                                  colors: {
                                    ...theme.colors,
                                    primary: '#76287C',
                                    primary25: '#F4DFF4',
                                  },
                                })}
                    ></Select>
                </div>

                {/* <div className="col-6">
                    <Select
                      styles={{
                        // Fixes the overlapping problem of the component
                        menu: provided => ({ ...provided, zIndex: 3 })
                      }}
                      placeholder="Offline Meet"
                      options={props.offlinemeetoptions}
                      onChange={props.selectedofflinemeetoptions}
                      value={props.selectedofflinemeetoptionsForFilter}
                              isClearable
                              className='react-select-container'
                              classNamePrefix="react-select"
                              theme={theme => ({
                                  ...theme,
                                  colors: {
                                    ...theme.colors,
                                    primary: '#76287C',
                                    primary25: '#F4DFF4',
                                  },
                                })}
                    ></Select>
                </div> */}


            </div>
            <div className="row conv-mt20">
                <div className="col-6">
                    <Select
						styles={{
							// Fixes the overlapping problem of the component
							menu: provided => ({ ...provided, zIndex: 3 })
						}}
						placeholder="Requested a callback"
						options={props.requestedaCallBackOptions}
						onChange={props.setSelectedRequestedaCallBackOption}
						value={props.selectedRequestedaCallBackOption}
                        className='react-select-container'
                        classNamePrefix="react-select"
                        theme={theme => ({
                            ...theme,
                            colors: {
                              ...theme.colors,
                              primary: '#76287C',
                              primary25: '#F4DFF4',
                            },
                          })}
					></Select>
                </div>
                <div className="col-6">
                  {
                    props.isForAdmin?
                    (
                      <Select
                          styles={{
                            // Fixes the overlapping problem of the component
                            menu: provided => ({ ...provided, zIndex: 3 })
                          }}
                          options={props.externalServicePartnerOptions}
                          onChange={props.onExternalServicePartnerChange}
                          value={props.selectedExternalServicePartner}
                          className='react-select-container'
                          classNamePrefix="react-select"
                          theme={theme => ({
                              ...theme,
                              colors: {
                                ...theme.colors,
                                primary: '#76287C',
                                primary25: '#F4DFF4',
                              },
                            })}
                      />
                      )
                      :("")
                    }  
                </div>


                <div className="col-6 conv-mt20">
                    <Select
                      styles={{
                        // Fixes the overlapping problem of the component
                        menu: provided => ({ ...provided, zIndex: 3 })
                      }}
                      placeholder="Offline Meet"
                      options={props.offlinemeetoptionsForFilter}
                      onChange={props.setselectedofflinemeetoptionsForFilter}
                      value={props.selectedofflinemeetoptionsForFilter}
                              isClearable
                              className='react-select-container'
                              classNamePrefix="react-select"
                              theme={theme => ({
                                  ...theme,
                                  colors: {
                                    ...theme.colors,
                                    primary: '#76287C',
                                    primary25: '#F4DFF4',
                                  },
                                })}
                    ></Select>
                </div>




            </div>
            <div className="row conv-mt20">
                <div className="col-4">
                </div>
                <div className="col-8">
                    <button 
                        type="button" 
                        className="con-btn-filled conv-float-right conv-pr35 conv-pl35"
                        onClick={(e) =>props.onSearchClicked(e)}>
                        Apply
                    </button>

                    <button 
                        type="button" 
                        className="con-btn-bordered-lg conv-float-right conv-mr25 conv-pl25 conv-pr25"
                        onClick={(e) =>props.onClearFilterSearch(e)}>
                        Clear All
                    </button>
                </div>
            </div>
        </div>
      </ModalContent>
    </Modal>
  );
}